import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDevopsDashbordQuery } from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";

export const getOpsDashboardStatsThunk=createAsyncThunk('opsDashboardStatsThunk',async(_request:any,{dispatch})=>{
try {
    const {data:{getDevopsDashbord}}:any = await API.graphql({
    ...graphqlOperation(getDevopsDashbordQuery),
    authMode: "AMAZON_COGNITO_USER_POOLS",
  })
    return getDevopsDashbord 
} catch (error) {
    
}
})